import React, { useState } from "react";
import "../../assets/styles/Navbar.css";
import { NavLink, useNavigate, useLocation, matchPath } from "react-router-dom";
import { LuCircleDollarSign, LuLayoutDashboard, LuLogOut, LuReceipt } from "react-icons/lu";
import { CiMenuFries } from "react-icons/ci";
import { ClearLocalData } from "../../Networking/localStorageHelper";
import { LiaIndustrySolid } from "react-icons/lia";
import { FaBuildingUser } from "react-icons/fa6";
import { AiFillFileText } from "react-icons/ai";
const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [activeSection, setActiveSection] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const activeClass = "bg-white/50 text-white-600 font-bold"; // Styles for active links

  const toggleNav = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      ClearLocalData("");
      navigate("/signin");
    }
  };

  const toggleSection = (section) => {
    setActiveSection((prevSection) => (prevSection === section ? null : section));
  };

  return (
    <div id="mySidebar" className={`sidebar ${isOpen ? "" : "closed"} ${!isOpen && window.innerWidth <= 768 ? "open" : ""}`}>
      <div className="sidebar-header">
        <button className="toggle-btn" onClick={toggleNav}>
          <CiMenuFries />
        </button>
      </div>

      <NavLink to="/dashboard" className={({ isActive }) => (isActive ? activeClass : "")}>
        <LuLayoutDashboard className="text-white" /> <span className="ps-3 text-[#ffffff]"> Dashboard</span>
      </NavLink>

      <NavLink to="/industry_management" className={({ isActive }) => (isActive ? activeClass : "")}>
      <LiaIndustrySolid  className="text-white"/> <span className="ps-3 text-[#ffffff]"> Industry Management</span>
      </NavLink>
   
      <div  >
        <div onClick={() => toggleSection("marchantManagement")} className="inline-flex items-center gap-4 ps-6 py-4 cursor-pointer text-[#ffffff]" >
          <FaBuildingUser className="text-white"/><span> {isOpen  ? "Merchant Management" : "" }</span>
        </div>
        {activeSection === "marchantManagement" && (
          <div className="pl-5">
            <NavLink to="/kyc_verification" className={({ isActive }) => (isActive ? activeClass : "text-[#ffffff] ")}>
              <span>KYC Verification</span>
            </NavLink>
            <NavLink to="/marchant_overview" className={({ isActive }) => (isActive ? activeClass : "hover:text-red-600")}>
              <span>Merchant Overview</span>
            </NavLink>
            <NavLink to="/merchant_transection" className={({ isActive }) => (isActive ? activeClass : "hover:text-red-600")}>
              <span>Transaction & Wallet</span>
            </NavLink>
            <NavLink to="/card-offer_management" className={({ isActive }) => (isActive ? activeClass : "hover:text-red-600")}>
              <span>Card Offer Management</span>
            </NavLink>
            <NavLink to="/banner-offer_management" className={({ isActive }) => (isActive ? activeClass : "hover:text-red-600")}>
              <span>Banner Offer Management</span>
            </NavLink>
          </div>
        )}
      </div>

      <div>
      <NavLink to="/customer_list" className={({ isActive }) => (isActive ? activeClass : "")}>
      <LuCircleDollarSign className="text-white" /> <span className="ps-3 text-[#ffffff]"> Customer Management</span>
      </NavLink>
        
      </div>

      <NavLink to="#">
        <LuReceipt  className="text-white" /> <span className="ps-3 text-[#ffffff]"> Admin Management</span>
      </NavLink>

      <NavLink to="/enquiries" className={({ isActive }) => (isActive ? activeClass : "hover:text-red")}>
      <AiFillFileText className="text-white"/> <span className="ps-3 text-[#ffffff]"> Enquiries </span>
      </NavLink>
    
      <NavLink to="#" onClick={handleLogout} className="hover:text-red">
        <LuLogOut  className="text-white"/> <span className="ps-3 text-[#ffffff]">Logout</span>
      </NavLink>
    </div>
  );
};

export default Sidebar;
